import { CapaciteStepEnum } from '../../constants/capacite-step.enum';
import { CapaciteSelectors } from '../../capacite.selectors';

export interface StepConfig {
  step: CapaciteStepEnum;
  conditions?: () => (state: any, ...states: any[]) => boolean; // wrappé dans une fonction pour éviter les erreurs dans l'ordre d'import
}

export const STEPS_CONFIG: Array<StepConfig> = [
  {
    step: CapaciteStepEnum.QUESTION_TYPE_PROPRIETE
  },
  {
    step: CapaciteStepEnum.REVENUS
  },
  {
    step: CapaciteStepEnum.MISE_DE_FONDS
  },
  {
    step: CapaciteStepEnum.HYPOTHEQUE,
    conditions: () => CapaciteSelectors.isResidenceSecondaire
  },
  {
    step: CapaciteStepEnum.DETTES
  },
  {
    step: CapaciteStepEnum.TYPE_DE_DEPENSES
  },
  {
    step: CapaciteStepEnum.DEPENSES_TOTALES,
    conditions: () => CapaciteSelectors.isCapaciteParDepenses
  },
  {
    step: CapaciteStepEnum.DEPENSES,
    conditions: () => CapaciteSelectors.isCapaciteParDepenses
  },
  {
    step: CapaciteStepEnum.PAIEMENT,
    conditions: () => CapaciteSelectors.isCapacitePaiementMaximal
  }
];
